/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { ArrowRight, Script } from '@carbon/react/icons';
import { ClickableTile } from 'carbon-components-react';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { ctaEvents } from '@ibm-watson/shared/modules/ia/util/trackers/segment';
import {
  channelTypeLinks,
  getServiceDeskChannelName,
  NICE_INCONTACT_BYOSD_TYPE
} from '../../../util/channelTypes';
import { ServiceDesk } from '../messages';

const NiceCard = () => {
  const selectedServiceDesk = NICE_INCONTACT_BYOSD_TYPE;
  const intl = useIntl();

  return (
    <ClickableTile
      className="ServiceDesk__tile"
      onClick={e => {
        e.preventDefault();
        window.open(channelTypeLinks[selectedServiceDesk], '_blank');
        ctaEvents.byosdSelected({
          category: getServiceDeskChannelName(selectedServiceDesk, 'webchat')
        });
      }}>
      <Script size={24} aria-hidden="true" />
      <p className="ServiceDesk__tile-title">
        <FormattedMessage {...ServiceDesk.webchatTitle} />
      </p>
      <div
        title={`${intl.formatMessage(
          ServiceDesk.rightArrowLabel
        )}${intl.formatMessage(ServiceDesk.logoLabel)}`}
        aria-hidden="true">
        <ArrowRight
          size={24}
          aria-label={intl.formatMessage(ServiceDesk.rightArrowLabel)}
          aria-hidden="true"
          className="ServiceDesk__tile-arrow"
        />
      </div>
    </ClickableTile>
  );
};

export { NiceCard };
